import validator from 'validator';

export type ParsedEmailListEntry = {
  value: string;
  isValid: boolean;
};

export type ParsedEmailList = {
  entries: ParsedEmailListEntry[];
  normalizedValue: string;
  hasInvalidEntries: boolean;
};

const extractEmailCandidates = (value: string): string[] => {
  const candidates: string[] = [];

  for (const group of value.split(/[,\r\n]+/)) {
    const angleBracketEmails = Array.from(group.matchAll(/<\s*([^<>]+?)\s*>/g));

    if (angleBracketEmails.length > 0) {
      candidates.push(...angleBracketEmails.map((match) => match[1]));
      continue;
    }

    candidates.push(...group.split(/\s+/));
  }

  return candidates;
};

export const parseEmailList = (value: string): ParsedEmailList => {
  const entries: ParsedEmailListEntry[] = [];
  const seen = new Set<string>();

  for (const candidate of extractEmailCandidates(value)) {
    const email = candidate.trim();
    if (!email || !email.includes('@') || !email.includes('.')) continue;

    const deduplicationKey = email.toLocaleLowerCase('en-GB');
    if (seen.has(deduplicationKey)) continue;
    seen.add(deduplicationKey);

    entries.push({
      value: email,
      isValid: validator.isEmail(email),
    });
  }

  return {
    entries,
    normalizedValue: entries.map(({ value: email }) => email).join('\n'),
    hasInvalidEntries: entries.some(({ isValid }) => !isValid),
  };
};
